import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import SignInIcon from "./icons/SignInIcon";
import styled from "styled-components";
import { Color, Colors } from "../styles/Colors";

const Button = styled.button`
  display: flex;
  justify-content: center; 
  align-items: center;
  border: none; 
  background-color: ${Color(Colors.blue)};
  border-radius: 4px;  
  height: 48px;
  padding: 0.5rem 1rem 0.5rem 1rem;



  & > span {
    color: ${Color(Colors.white)}; 
  }

  & > svg {
    fill: ${Color(Colors.white)}; 
    margin: 0 4px 0 0; 
    height: 24px; 
    width: auto; 
  }

  &:hover {
    background-color: ${Color(Colors.lightBlue)};
  }

  @media (max-width: 1150px) {
    height: 38px;
  }
`;


export const SignInButton = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((e) => {
        console.log(e);
      });
  };
  return (
    <Button onClick={() => handleLogin()}>
      <SignInIcon />
      <span>Logga in</span>
    </Button>
  );
};